import validate from "/home/runner/work/ronaldo-web/ronaldo-web/node_modules/.pnpm/nuxt@4.0.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.0_@types+node@22.10.5_@vue+compiler_ac4a8dc9b951a84a5b3379d227015290/node_modules/nuxt/dist/pages/runtime/validate.js";
import setup_45global from "/home/runner/work/ronaldo-web/ronaldo-web/app/common/middleware/setup.global.ts";
export const globalMiddleware = [
  validate,
  setup_45global
]
export const namedMiddleware = {}